export const theme = {
  axis: {
    domain: {
      line: {
        stroke: '#dddddd',
        strokeWidth: 1,
      },
    },
    ticks: {
      line: {
        stroke: 'transparent',
        strokeWidth: 1,
      },
    },
  },
  grid: {
    line: {
      stroke: '#dddddd',
      strokeWidth: 1,
    },
  },
};
